import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EventsRefreshService {

  public messageSource = new BehaviorSubject("");
  public currentMessage:Observable<string> = this.messageSource.asObservable();
  constructor() { }

  changeMessage(message:string) {
    this.messageSource.next(message);
  }

  getMessage() {
    take(1);
    return this.currentMessage;
  }

}
